// Countries are stored in Baserow as lowercase slugs ("deutschland", "oesterreich",
// "schweiz") — the option values of the register form. Anywhere a stored value is
// shown to the customer again (return form prefill, Rückgabeformular PDF) it has to
// be turned back into the label of the current page language.
const COUNTRY_LABELS = {
  de: {
    deutschland: 'Deutschland',
    oesterreich: 'Österreich',
    schweiz: 'Schweiz',
  },
  fr: {
    deutschland: 'Allemagne',
    oesterreich: 'Autriche',
    schweiz: 'Suisse',
  },
};

// Form fields carrying such a slug.
export const COUNTRY_FIELDS = ['country', 'retailer_country'];

// Unknown values are passed through unchanged (already localized, or a country
// that was added later).
export function localizeCountry(value, lang) {
  if (typeof value !== 'string') return value;
  const code = (lang || 'de').split('-')[0].toLowerCase();
  const table = COUNTRY_LABELS[code] || COUNTRY_LABELS.de;
  return table[value.trim().toLowerCase()] || value;
}